module.exports = __webpack_public_path__ + "img/bh_3.29c3e73e.jpg";